import React, { FunctionComponent } from 'react';

import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import 'core/rating-as-recommends/RatingAsRecommends.scss';

export interface Props {
    className?: string;
    isRecommended?: boolean;
}

export const RatingAsRecommends: FunctionComponent<Props> = ({ className, isRecommended }) => {
    const { t } = useTranslation('core/rating');
    const label = t(isRecommended ? 'RECOMMENDED' : 'NOT_RECOMMENDED');

    return (
        <div
            className={classnames('r4e-rating-as-recommends', className, {
                'state-recommended': isRecommended,
                'state-not-recommended': !isRecommended,
            })}
        >
            <i className="icon-facebook-recommendation" />
            {label}
        </div>
    );
};

RatingAsRecommends.defaultProps = {
    isRecommended: false,
};
